const state = {
	SUCCESS: 'Success',
	ERROR: 'Failed',
}

export const logger = {
	/**
	 * Add log when process submit form
	 * @param {Array} pathObj state array
	 * @param {String} step step
	 * @param {Object} error error message
	 */
	setLogSubmit(pathObj, step, error = null) {
		const isoDate = new Date().toISOString()
		let message = `${isoDate} - Step: ${step}`
		if (error) {
			message += ` - ${state.ERROR}: ${error}`
		}
		pathObj.push(message)
	},

	/**
	 * Set log info
	 * @param {Array} logs List log in form display json data
	 * @param {Number} currentStep
	 * @param {Array} error String array
	 */
	setLog(logs, currentStep, error = []) {
		const info = {
			step: `Step ${currentStep}`,
			status: error.length ? state.ERROR : state.SUCCESS,
			message: error.length ? [...error] : [],
		}

		// Add new step if not exist
		let currentInfo = logs.find((v) => v.step === info.step)
		if (currentInfo) {
			currentInfo = info
		} else {
			logs.push(info)
		}
	},
}
